export type TypeaheadTexts = {
  /** A message displayed in the typeahead when the search phrase yields no results */
  noResult: string;
  /** A message ready by screen readers when the typeahead is focused, but no value has been typed */
  screenReaderDescription: string;
  /** A message read by screen readers when the search phrase yields no results */
  screenReaderNoResult: string;
  /** A message read by screen readers when a result in the list is focused */
  screenReaderFocusedResultInList: string;
  /** A message read by screen readers when a search phrase has been typed, but no result is focused */
  screenReaderResultList: string;
  /** A message displayed when there are more options than the limit set by numberOfOptionsToDisplay */
  overflowResultMessage: string;
};

export const typeaheadTextsNO: TypeaheadTexts = {
  noResult: 'Beklager, søket ga ingen resultater',
  screenReaderDescription: 'Skriv for å søke.',
  screenReaderNoResult: 'Beklager, søket ga ingen resultater.',
  screenReaderFocusedResultInList: '{{result}}. {{index}} av {{length}} treff.',
  screenReaderResultList: '{{length}} treff. Bruk piltastene for å bla i listen.',
  overflowResultMessage: '+{{length}} treff',
} as const;

export const typeaheadTextsDK: TypeaheadTexts = {
  noResult: 'Beklager, din søgning gav ingen resultater',
  screenReaderDescription: 'Skriv for at søge.',
  screenReaderNoResult: 'Beklager, din søgning gav ingen resultater.',
  screenReaderFocusedResultInList: '{{result}}. {{index}} af {{length}} resultater.',
  screenReaderResultList: '{{length}} resultater. Brug piletasterne til at bladre i listen.',
  overflowResultMessage: '+{{length}} resultater',
} as const;
